<div *ngIf="recording">
  {{timeStamp}} <br *ngIf=""> {{samplesCount}}
</div>
